import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import {
  SbeSmsApiService,
  type ListNotificationsResponseDto,
  type MarkAllNotificationsReadResponseDto,
  type UnreadCountResponseDto,
} from '@sbe-spinoff-client/sbe-sms-api';

/**
 * 통합 인박스(2026-08-06) — 개인/org 컨텍스트 구분 없이 로그인 사용자의 알림 전부를 다룬다.
 * org 라우트가 없어 `spinoffAuthInterceptor`의 org-scoped 토큰 자동 부착과 무관하다.
 */
@Injectable({ providedIn: 'root' })
export class NotificationsApiService {
  private readonly api = inject(SbeSmsApiService);

  list(params: { page?: number; size?: number } = {}): Observable<ListNotificationsResponseDto> {
    return this.api.spinoffNotificationsControllerList<ListNotificationsResponseDto>(params);
  }

  unreadCount(): Observable<UnreadCountResponseDto> {
    return this.api.spinoffNotificationsControllerUnreadCount<UnreadCountResponseDto>();
  }

  markRead(id: string): Observable<void> {
    return this.api.spinoffNotificationsControllerMarkRead<void>(id);
  }

  markAllRead(): Observable<MarkAllNotificationsReadResponseDto> {
    return this.api.spinoffNotificationsControllerMarkAllRead<MarkAllNotificationsReadResponseDto>();
  }
}
